import { GetDeliveryGroupsQueryKey, SubscriptionDeliveryDeliveryGroupModelQueryKey } from 'autogen/swagger/all/hooks';
import { updateBasket } from 'components/basket/shared/basket';
import queryClient from 'setup/react-query/queryClient';

export default async function updateBasketAndCheckout() {
    updateBasket();
    await Promise.all([
        queryClient.invalidateQueries({ queryKey: [GetDeliveryGroupsQueryKey] }),
        queryClient.invalidateQueries({ queryKey: [SubscriptionDeliveryDeliveryGroupModelQueryKey] })
    ]);
}
